(() => {
  'use strict';

  function initializeProducts(root) {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.commerceReady) return;
      const dataElement = section.querySelector('[data-product-variants]');
      const select = section.querySelector('[data-variant-select]');
      if (!dataElement || !select) return;
      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }
      section.dataset.commerceReady = 'true';
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const unitPrice = section.querySelector('[data-unit-price]');
      const quantity = section.querySelector('[data-product-quantity]');
      const rule = section.querySelector('[data-quantity-rule]');
      const add = section.querySelector('[data-product-add]');
      const media = Array.from(section.querySelectorAll('[data-media-id]'));
      const thumbs = Array.from(section.querySelectorAll('[data-show-media]'));
      const stickyAdd = section.querySelector('[data-sticky-add]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const status = section.querySelector('[data-product-status]');
      const savings = section.querySelector('[data-product-savings]');
      const sticky = section.querySelector('[data-product-sticky]');
      let stickyObserver;
      if (sticky && 'IntersectionObserver' in window) {
        sticky.hidden = true;
        const updateSticky = () => { sticky.hidden = add.getBoundingClientRect().bottom >= 0; };
        stickyObserver = new IntersectionObserver(updateSticky, { threshold: 0 });
        stickyObserver.observe(add);
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        section.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{
          stickyObserver.disconnect();
          window.removeEventListener('scroll', updateSticky);
          window.removeEventListener('resize', updateSticky);
        },{once:true});
      }
      const adjusters = [...section.querySelectorAll('[data-quantity-adjust]')];
      function updateQuantityControls() {
        adjusters.forEach(button => {
          button.disabled = Number(button.dataset.quantityAdjust) < 0
            ? Number(quantity.value) <= Number(quantity.min)
            : quantity.hasAttribute('max') && Number(quantity.value) >= Number(quantity.max);
        });
      }
      adjusters.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (Number(button.dataset.quantityAdjust) < 0) quantity.stepDown();
          else quantity.stepUp();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      quantity.addEventListener('input', updateQuantityControls);
      quantity.addEventListener('change', updateQuantityControls);

      function showMedia(id) {
        const active = media.find((item) => item.dataset.mediaId === String(id)) || media[0];
        if (!active) return;
        media.forEach((item) => {
          item.hidden = item !== active;
          if (item.hidden) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            // Reload hidden external players to stop playback without provider APIs.
            item.querySelectorAll('iframe').forEach((frame) => {
              if (frame.dataset.commercePlaying === 'true') {
                frame.src = frame.src;
                frame.dataset.commercePlaying = 'false';
              }
            });
          } else {
            item.querySelectorAll('iframe').forEach((frame) => {
              frame.dataset.commercePlaying = 'true';
            });
          }
        });
        thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.dataset.showMedia === active.dataset.mediaId)));
      }

      function updateVariant(updateUrl) {
        const variant = data.variants.find((item) => String(item.id) === select.value);
        if (!variant) return;
        const plainMoney = value => new DOMParser().parseFromString(value || '', 'text/html').body.textContent;
        price.textContent = plainMoney(variant.price);
        compare.textContent = plainMoney(variant.compare);
        compare.hidden = !variant.compare;
        unitPrice.textContent = plainMoney(variant.unitPrice);
        unitPrice.hidden = !variant.unitPrice;
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
        if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = add.textContent; }
        if (stickyPrice) stickyPrice.textContent = plainMoney(variant.price);
        if (status) { status.textContent = variant.available ? 'Available to order' : 'Sold out'; status.classList.toggle('is-unavailable', !variant.available); }
        if (savings) {
          const discounted = Number(variant.compareCents) > Number(variant.priceCents);
          savings.hidden = !discounted;
          savings.textContent = discounted ? `SAVE ${Math.round((variant.compareCents - variant.priceCents) / variant.compareCents * 100)}%` : '';
        }
        const min = Number(variant.min) || 1;
        const step = Number(variant.step) || 1;
        const max = variant.max == null ? null : Number(variant.max);
        quantity.min = String(min);
        quantity.step = String(step);
        if (max == null) quantity.removeAttribute('max');
        else quantity.max = String(max);
        let value = Math.max(min, Number(quantity.value) || min);
        if (max != null) value = Math.min(value, max);
        quantity.value = String(min + Math.floor((value - min) / step) * step);
        rule.textContent = `Minimum ${min}${max == null ? '' : `, maximum ${max}`}; increments of ${step}.`;
        updateQuantityControls();
        showMedia(variant.mediaId);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState(window.history.state, '', url);
        }
      }

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.showMedia)));
      const thumbnailList = section.querySelector('[data-media-thumbs]');
      if (thumbnailList) thumbnailList.hidden = false;
      select.addEventListener('change', () => updateVariant(true));
      updateVariant(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProducts(document));
  } else {
    initializeProducts(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeProducts(event.target));
})();
